<template>
  <div>
    <h2 class="mt-4">Reset password</h2>

    <form class="mt-3" @submit.prevent="onSubmit">

      <div class="alert alert-danger" v-if="errors.length">
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </div>

      <div class="form-group" :class="{invalid: $v.email.$error}">
        <label for="email">Email</label>
        <input type="email"
               class="form-control"
               id="email"
               @blur="$v.email.$touch()"
               v-model="email">
      </div>

      <div class="form-group" :class="{invalid: $v.password.$error}">
        <label for="password">New Password</label>
        <input type="password"
               class="form-control"
               id="password"
               @blur="$v.password.$touch()"
               v-model="password">
      </div>

      <p v-if="!$v.password.minLen">Password have to be at least {{ $v.password.$params.minLen.min }} characters long.</p>

      <div class="form-group" :class="{invalid: $v.confirmPassword.$error}">
        <label for="password_confirmation">Repeat password</label>
        <input type="password"
               class="form-control"
               id="password_confirmation"
               @blur="$v.confirmPassword.$touch()"
               v-model="confirmPassword">

        <p v-if="!$v.confirmPassword.sameAs">Passwords doesn't match</p>
      </div>

      <button type="submit" class="btn btn-dark" :disabled="$v.$invalid">Reset</button>
    </form>
  </div>
</template>

<script>
  import { required, email, numeric, minValue, minLength, sameAs, requiredUnless } from 'vuelidate/lib/validators'
  import axios from 'axios'

  export default {
    data() {
      return {
        token: '',
        email: '',
        password: '',
        confirmPassword: '',
        errors: []
      }
    },

    methods: {
      onSubmit() {
        const data = {
          email: this.email,
          password: this.password,
          password_confirmation: this.confirmPassword,
          token: this.token
        }

        axios.post('/reset-password', data)
          .then(res => {
            this.$emit('messageEvent', 'You password has been changed successfully. You can log in now')
            this.$router.push({ name: 'login' })
          })
          .catch(error => {})
      }
    },

    validations: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLen: minLength(6),
      },
      confirmPassword: {
        sameAs: sameAs(vm => vm.password)
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (vm.$route.query.token) {
          vm.token = vm.$route.query.token
          next()
        } else {
          vm.$router.replace({name: 'reset_password.request'})
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/ResetPasswordPage.vue